import { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '@/config';

const ACCENTS = ['#20acf6', '#02d1d4', '#10B981', '#F59E0B', '#8B5CF6', '#EF4444', '#F97316', '#2a3e5d', '#6366F1'];

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/categories`).then((r) => {
      setCategories((r.data || []).map((c, i) => ({ ...c, accent: ACCENTS[i % ACCENTS.length] })));
    }).catch(() => setCategories([]));
  }, []);
  return categories;
};
